import { CommonModule } from '@angular/common';
import { HttpClient, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { Injector, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { SeFeAlertModule } from 'se-fe-alert';
import { SeFeFormFieldModule } from 'se-fe-form-field';
import { SeFeFormFieldSelectModule } from 'se-fe-form-field-select';

import { HttpLoaderFactory } from '../app/shared.module';
import { PayoutAccountSelectorComponent } from './payout-account-selector.component';

@NgModule({
  declarations: [ PayoutAccountSelectorComponent ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    ReactiveFormsModule,
    SeFeAlertModule,
    SeFeFormFieldModule,
    SeFeFormFieldSelectModule,
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
  ],
  providers: [
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
  ],
})
export class PayoutAccountSelectorModule {
  constructor(private injector: Injector) {}

  public ngDoBootstrap() {
    const el = createCustomElement(PayoutAccountSelectorComponent, { injector: this.injector });
    if (!customElements.get('payout-account-selector-element')) {
      customElements.define('payout-account-selector-element', el);
    }
  }
}
